import React from 'react'
import { H1, P2 } from './ActivityStyledComponents'

const FullDescription = props => {
  const { cardDataFullDescription, cardDataGoals, cardDataPreparation, cardDataRequisites } = props
  return (
    <>
      {cardDataFullDescription[0]
        ? <div style={{ padding: '0 20px' }}>
          {cardDataFullDescription.map((item, index) => {
            return (
              <P2 key={index}> {item.text}</P2>
            )
          })}
        </div>
        : ''}

      {cardDataGoals[0]
        ? <div style={{ padding: '0 20px', marginTop: '18px' }}>
          <H1>Goals</H1>
          {cardDataGoals.map((item, index) => {
            return (
              <P2 key={index}> {item.text}</P2>
            )
          })}
        </div>
        : ''}

      {cardDataRequisites[0]
        ? <div style={{ padding: '0 20px', marginTop: '18px' }}>
          <H1>Tools</H1>
          {cardDataRequisites.map((item, index) => {
            return (
              <P2 key={index}> {item.text}</P2>
            )
          })}
        </div>
        : ''}

      {cardDataPreparation[0]
        ? <div style={{ padding: '0 20px', marginTop: '18px' }}>
          <H1>Preparation</H1>
          {cardDataPreparation.map((item, index) => {
            return (
              <P2 key={index}> {item.text}</P2>
            )
          })}
        </div>
        : ''}
    </>
  )
}

export default FullDescription
